import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-1019",
  "use": "icon-1019-usage",
  "viewBox": "0 0 26.417 20.387",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 26.417 20.387\" id=\"icon-1019\">\r\n  <g id=\"icon-1019_sy-zxdc\" transform=\"translate(0 0)\">\r\n    <path id=\"icon-1019_路径_677\" data-name=\"路径 677\" d=\"M364.373,524.137c-7.752-5.687-14.8-2.392-17.444.147a1.748,1.748,0,0,0,2.415,2.528c.231-.215,5.687-5.2,12.965.141a1.714,1.714,0,0,0,1.032.338,1.746,1.746,0,0,0,1.033-3.154Zm-3.306,5.975c-4.79-3.515-9.185-1.439-10.843.146a1.748,1.748,0,1,0,2.42,2.522c.107-.1,2.7-2.527,6.352.147a1.71,1.71,0,0,0,1.033.339,1.748,1.748,0,0,0,1.038-3.154Z\" transform=\"translate(-342.526 -512.88)\" fill=\"#00a700\" />\r\n    <path id=\"icon-1019_路径_678\" data-name=\"路径 678\" d=\"M278.383,407.652a1.747,1.747,0,0,0,2.448,2.494c.384-.372,9.568-9.072,20.581.1a1.749,1.749,0,0,0,2.234-2.691C290.174,396.334,278.5,407.539,278.383,407.652Z\" transform=\"translate(-277.862 -402.567)\" fill=\"#00a700\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/1019.svg
// module id = 6gcY
// module chunks = 5